<template>
  <resource-search
    search-context="own"
    :resource-props="{
      'is-read-only': false,
      'show-user': false
    }"
    :allow-all-tags="false"
  >
    <template v-slot:header>
      <div class="flex items-center">
        <nice-icon
          icon="user"
          class="mr3 has-text-primary search-header-icon"
        ></nice-icon>
        <heading size="medium" :spacing-bottom="false">{{
          $t("nav.myResources")
        }}</heading>
      </div>
    </template>

    <template v-slot:empty>
      <b-message>
        Seems like you haven't saved any resources.
        <br />
        <br />Click the button with the plus icon in the bottom right to
        <router-link to="/resource">add a resource</router-link>. <br />If you
        copy the URL of the resource first, we will grab it from your clipboard
        and prefill the inputs.
        <br />
        <br />A browser extension for Chrome and Firefox is comming very soon.
      </b-message>
    </template>

    <template v-slot:searchResultEmpty="slotProps">
      <b-message>
        <p>You don't have any resources for that combination.</p>
        <p>
          You can check public resources to find resources from others that
          match your search.
        </p>
        <b-button
          class="mt3"
          type="is-primary"
          tag="router-link"
          :to="{
            name: 'explore',
            query: {
              tags: slotProps.searchTags
                ? slotProps.searchTags
                    .map(t => $utils.removeNonAsciiChars(t.text).trim())
                    .join(',')
                : ''
            }
          }"
          >Explore public resources</b-button
        >
      </b-message>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from "@/components/resource/Search.vue";

export default {
  data() {
    return {};
  },

  computed: {},

  components: {
    ResourceSearch
  }
};
</script>

<style lang="scss" scoped></style>
